import {
  extendsModule, baseFormGroup, registerMfModule, moduleKeys,
} from 'src/store/base';
import playableName from './playable-name';
import playableParameter from './playable-parameter';
import playableQrCodePreview from './playable-qr-code-preview';
import playableUrl from './playable-url';

export default extendsModule(baseFormGroup, {
  state: {
    _moduleKey: 'check-form-group',
    _formItems: moduleKeys([playableName, playableUrl, playableParameter, playableQrCodePreview]),
  },
  modules: registerMfModule([playableName, playableUrl, playableParameter, playableQrCodePreview]),
});
